(()=>{
  const current=document.currentScript?.src||[...document.scripts].map(s=>s.src).find(src=>/\/product-form\.js(?:\?|$)/.test(src))||'';
  if(!current)return;
  const base=name=>current.replace(/product-form\.js(?:\?.*)?$/,name);
  const V='20260819-1108';
  const original=document.createElement('script');
  original.src=base('product-form-original-nc.js')+'?v='+V;
  original.async=false;
  document.head.appendChild(original);
  if(!location.pathname.includes('/products/'))return;
  if(!document.getElementById('nc-storefront-tax-hide')){
    const style=document.createElement('style');
    style.id='nc-storefront-tax-hide';
    style.textContent='.product__tax{display:none!important}';
    document.head.appendChild(style);
  }
  const wizardCss=document.createElement('link');
  wizardCss.rel='stylesheet';wizardCss.href=base('nc-bed-wizard.css')+'?v='+V;document.head.appendChild(wizardCss);
  const hoeslaken=/\/products\/(?:double-jersey-220-gr-hoeslaken-grijs|dubbel-jersey-220-gr-hoeslaken-(?:wit|creme|antraciet|navy|rood|roze|pastel-blauw|zwart))(?:[/?#]|$)/.test(location.pathname);
  if(hoeslaken){const css=document.createElement('link');css.rel='stylesheet';css.href=base('nc-hoeslaken-configurator.css')+'?v='+V;document.head.appendChild(css)}
  original.addEventListener('load',()=>{
    const js=document.createElement('script');
    js.src=base(hoeslaken?'nc-hoeslaken-configurator.js':'nc-universal-configurator.js')+'?v='+V;
    js.async=false;
    document.head.appendChild(js);
  });
})();
